// extracted by mini-css-extract-plugin
export default {"badge":"RoleBadge_badge__G3luY","superadmin":"RoleBadge_superadmin__mFupQ","admin":"RoleBadge_admin__a58Oo","user":"RoleBadge_user__gwIhY"};